import {Bot} from "./bot";
import {RoleRegistration} from "./role-registration";
import {RoleStatus} from "./role-status";
import {TutorialBase} from "./tutorial-base";

export class Role extends TutorialBase {
  public id: string;
  public name: string;
  public type: string = "UserRole";
  public shortName: string;
  public description: string;
  public startRole: boolean;
  public collectionDateEnabled: boolean = false;
  public assignedTo: string;
  public statuses: RoleStatus[];
  public registrations: RoleRegistration[];
  public sortOrderNumber: number;
  public visibleForApplicant: boolean;
  public jsonDeterminants: string;
  public formSchema: any = {components: []};
  public nextRoles: any;
  public bot: Bot;
  public botId: string;
  public camundaName: string;
  public allowAccessToFinancialReports: boolean = false;
  public allowToConfirmPayments: boolean = false;
  public repeatUntilSuccessful: boolean = false;
  public repeatInMinutes: number;
  public repeatInHours: number;
  public repeatInDays: number;
  public durationInMinutes: number;
  public durationInHours: number;
  public durationInDays: number;
  public classificationTypeId: string;
  public isGhostInCamunda: boolean = false;
  public serverWhereGhostExists: any;
  public businessKey: string;

  // should be removed
  public botServiceId: string;
  public isFrontendBot: boolean;
  public category: string;
  public botSuccessMessage: string;
  public botSFailMessage: string;
  public botType: string;
  public selectedPrint: string;
  public botRoleBots: any;
}
